// styled.js
import styled from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  height: 100vh;
`;

export const ImageSection = styled.img`
  flex: 1;
  object-fit: cover;
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #212121;
  color: white;
  padding: 40px;
`;

export const Form = styled.form`
  width: 100%;
  max-width: 400px;
`;
